<template>
  <section class="medias-list">
    <p class="task-description">{{ taskToShowMedias?.description }}</p>

    <div class="time-information">
      <div class="time-card">
        <p class="time mb-0">{{ formatTimeToHHMM(taskToShowMedias?.estimated_time) }}</p>
        <p class="description mb-0">Tempo estimado</p>
      </div>
      <div class="time-card">
        <p class="time mb-0">{{ totalTime }}</p>
        <p class="description mb-0">Tempo trabalhado</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TaskMediasList',
  computed: {
    taskToShowMedias() {
      return this.$store.getters['ServiceOrderTask/getTaskToShowMedias'];
    },
    taskIntervalActive() {
      return this.$store.getters['ServiceOrderTask/getServiceOrderTaskIntervalActive'];
    },
    taskIntervalActiveTotalTime() {
      return this.$store.getters['ServiceOrderTask/getTaskIntervalActiveTotalTime'];
    },
    totalTime() {
      if (this.taskToShowIntervalsHistory) {
        return this.calculateTotalTime(this.taskToShowIntervalsHistory.task_intervals, this.taskIntervalActiveTotalTime);
      }
      return '00:00';
    }
  },

  methods: {
    openModalLogs() {
      this.isModalLogsActive = true;
    },
    closeModalLogs() {
      this.isModalLogsActive = false;
    },
    calculateTotalTime(intervals, taskIntervalActiveTotalTime) {
      let totalMilliseconds = 0;

      intervals.forEach((interval) => {
        if (interval?.id === this.taskIntervalActive?.id) {
          totalMilliseconds += taskIntervalActiveTotalTime;
        } else {
          const startDate = new Date(interval.start_date);
          const endDate = new Date(interval.end_date);
          startDate.setSeconds(0, 0);
          endDate.setSeconds(0, 0);
          totalMilliseconds += endDate - startDate;
        }
      });

      const totalMinutes = Math.floor(totalMilliseconds / 60000);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    },
    formatTimeToHHMM(time) {
      if (!time) return '';
      const [hours, minutes] = time.split(':');
      return `${hours}:${minutes}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.medias-list {
  padding: 18px;
  background-color: #edf2f7;
  min-height: 100vh;
  margin-top: 70px;

  .task-description {
    color: #718096;
    font-size: 16px;
    font-weight: 400;
    text-align: start;
  }

  .custom-btn {
    background-color: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    letter-spacing: 0.3px;
    text-transform: none;

    p {
      color: #4a5568;
      font-weight: 600;
      font-size: 16px;
    }
  }

  .time-information {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;

    .time-card {
      align-items: center;
      background-color: #fff;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 12px;
      width: 48%;

      .time {
        color: #000000;
        font-size: 14px;
        font-weight: 500;
      }

      .description {
        color: #718096;
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
}
</style>
